<template>
  <b-sidebar
    id="sidebar-send-invoice"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    v-model="isSidebarVisible"
    width="500px"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{
            type && type == "RevenueInvEmail"
              ? "Send Invoice"
              : type && type == "RoyaltyInvEmail"
              ? "Send Report"
              : "Send"
          }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <!-- From -->
        <b-form-group label="From" label-for="from">
          <b-form-input
            :disabled="true"
            id="from"
            v-model="sendInvoiceData.from"
            trim
            type="email"
          />
        </b-form-group>

        <!-- To -->
        <!-- <b-form-group label="To" label-for="to">
          <b-form-input
            id="to"
            v-model="sendInvoiceData.to"
            aria-placeholder="to"
            trim
          /> -->
        <b-form-group class="mr-1" style="width: 445px" label="To">
          <v-select
            v-model="sendInvoiceData.to"
            placeholder="Receipient Email"
            :options="contact_emails"
            label="emailId"
            :reduce="(email) => email.emailId"
            multiple
          >
          <template #no-options="data">
            <b-button
              @click="handleNewContact()"
            >
              Add New Contact
            </b-button>
          </template>
        </v-select>
        </b-form-group>
        <!-- <datalist id="email-options">
            <option
              v-for="(email, index) in receivedData.email"
              :key="index"
              :value="email"
              v-if="receivedData.email.length>0"
            >
              {{ email }}
            </option>
          </datalist> -->
        <!-- </b-form-group> -->

        <!-- Subject -->
        <b-form-group label="Subject" label-for="subject">
          <b-form-textarea id="subject" v-model="sendInvoiceData.subject" trim rows="1" max-rows="5" no-resize/>
        </b-form-group>

        <!-- Message -->
        <b-form-group label="Message" label-for="message">
          <!-- <b-form-textarea
            id="message"
            :disabled="true"
            v-model="sendInvoiceData.message"
            rows="12"
            trim
          /> -->
          <quill-editor
            :id="message"
            v-model="sendInvoiceData.message"
            :options="{ theme: 'snow' }"
          />
        </b-form-group>

        <!-- ? File/Attachement -->
        <b-badge style="background-color: white; color: black">
          <div v-if="receivedData.documents" class="mt-2">
            <!-- <b-badge> -->
            <span
              style="
                text-align: left;
                color: black;
                display: flex;
                justify-content: flex-start;
              "
              >Attached documents:</span
            >
            <!-- </b-badge> -->
            <ul
              class="list-unstyled mt-1"
              style="
                display: flex;
                flex-direction: column;
                gap: 2%;
                color: black;
              "
            >
              <li
                v-for="(doc, index) in receivedData.documents"
                :key="index"
                class="mb-1"
                style="
                  display: flex;
                  align-items: center;
                  gap: 1%;
                  white-space: normal;
                  overflow: visible;
                  text-overflow: unset;
                  word-break: break-word;
                  color: black;
                "
              >
                <b-form-checkbox v-model="doc.isSelected" />
                <span style="color: black; overflow: visible; flex-shrink: 0">{{
                  doc.name || "Document " + (index + 1)
                }}</span>
              </li>
            </ul>
          </div>
        </b-badge>
        <div class="d-flex mt-2">
          <b-button
            :disabled="
              !sendInvoiceData.from ||
              !sendInvoiceData.subject ||
              !sendInvoiceData.to ||
              !sendInvoiceData.message ||
              loading
                ? true
                : false
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="send"
          >
            <b-spinner v-if="loading" small /> Send
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BBadge,
  BSpinner,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import { SendInvoiceEmail } from "@/apiServices/RevenueServies";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";

export default {
  props: {
    id: Number,
    type: String,
  },

  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BBadge,
    BSpinner,
    ToastificationContentVue,
    vSelect,
    quillEditor
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isDocumentSelected: false,
      selectedItems: [],
      allItems: [],
      moment:moment,
    };
  },
  setup() {
    const sendInvoiceData = ref({
      from: "info@praesens.com",
      to: "",
      subject: "Praesens-Film: Royalty Reports for #{movie} as per #{date}",
      message: `
        <p>Dear Accounting Team,</p>
        <p>Please find attached our Royalty Report for the period (#{dateFrom} to #{dateTo}).</p>
        <p>Kindest regards,</p>
        <p>Simone Zumbrunn</p>
        <p>
          Accounting &amp; Adminstration<br>
          Praesens-Film AG<br>
          Münchhaldenstr. 10<br>
          8008 Zürich<br>
          Tel. +41 44 325 35 25<br>
          Tel. +41 44 325 35 21 direkt
        </p>
      `.trim().replace(/\n\s+/g, '')
    });
    const loading = ref(false);
    const isSidebarVisible = ref(false);
    const typeValue = ref("");

    const receivedData = ref({
      documents: null,
      id: null,
    });

    const contact_emails = ref([]);
    const dateTo = ref("");
    const dateFrom = ref("");
    const handleToggle = (index) => {
      console.log("toggleTriggered");
      receivedData.value.documents[index].isSelected =
        !receivedData.value.documents[index].isSelected;
      console.log(receivedData.value.documents[index], "updated value");
    };
    const showSidebar = (dataArray, emails) => {
      const processArray = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr.map((item) => {
          if (Array.isArray(item)) {
            return { name: item[0], isSelected: true, file: item[1] };
          }
          return { name: item, isSelected: true, file: item };
        });
      };
      const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
      const current_date = new Date();
      let CurrentDate = null;
      console.log("Date: ", dataArray.dateTo)
      if(!dataArray?.dateTo){
        CurrentDate = formatDate(current_date.toISOString())
      }else{
        CurrentDate = moment(dataArray.dateTo).format("DD/MM/YYYY");
      }
      receivedData.value = {
        documents: [
          dataArray?.royalty_report_document
            ? {
                name: dataArray?.royalty_report_document,
                isSelected: true,
                file: dataArray?.royalty_report_document,
              }
            : null,
          ...processArray(dataArray?.royalty_report_extra_document),
        ],
        id: dataArray?.royalty_report_id || null,
        vendor_id: dataArray?.vendor_id || null,
      };
      isSidebarVisible.value = true;
      sendInvoiceData.value.subject = sendInvoiceData.value.subject.replace(
        /#{date}/g,
        CurrentDate
      )
      .replace(/#{movie}/g, dataArray?.movie_title);
      contact_emails.value = emails.flat();
      dateTo.value = formatDate(dataArray?.dateTo.split("T")[0]);
      dateFrom.value = formatDate(dataArray?.dateFrom.split("T")[0]);
      sendInvoiceData.value.message = sendInvoiceData.value.message
        .replace(/#{dateFrom}/g, dateFrom.value)
        .replace(/#{dateTo}/g, dateTo.value);
    };

    return {
      sendInvoiceData,
      loading,
      isSidebarVisible,
      typeValue,
      receivedData,
      handleToggle,
      showSidebar,
      contact_emails,
      dateTo,
      dateFrom,
    };
  },
  methods: {
    handleFiltering(dataArray) {
      console.log("Array recieved for filtering", dataArray);
      return dataArray.filter((item) => item.isSelected === true);
    },
    async send() {
      this.loading = true;
      const data = this.handleFiltering(this.receivedData.documents);
      try {
        let payload = {
          sendInvoiceData: this.sendInvoiceData,
          id: this.receivedData.id,
          type: this.type,
          files:data
        };
        const response = await SendInvoiceEmail(payload);
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Email Sent Successfully",
              icon: "EditIcon",
              variant: "primary",
            },
          });
        }
        this.loading = false;
        this.isSidebarVisible = false;
      } catch (err) {
        this.loading = false;
        console.log("Email Sent", err);
      }
    },
    handleNewContact(){
      // console.log(this.receivedData, 'vendorId');
      const vendorId = this.receivedData.vendor_id;
      if (vendorId) {
        this.$router.push(`/contacts/form/${vendorId}`);
      } else {
        console.error('Vendor ID is not available');
      }
    }
  },
};
</script>

<style></style>
